import { create } from "zustand";
import { AnyRole, ROLE_HIERARCHY } from "@/enums/auth.service";

interface AuthUser {
  id: string;
  email: string;
  name: string;
  phone?: string;
  role: AnyRole;                    // Single role (primary system)
  permissions?: string[];          // COMPUTED: User permissions based on role
}

interface AuthState {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  userRole: AnyRole | null;              // Current user role
  userPermissions: string[];             // Computed permissions
  setUser: (user: AuthUser | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  logout: () => void;
  hasPermission: (permission: string) => boolean;  // Permission checker
  hasRole: (role: string) => boolean;              // Role checker with hierarchy
  updateRole: (role: AnyRole) => void;             // Update user role
}

// Helper function to compute permissions based on role
const computePermissions = (role: AnyRole): string[] => {
  const directPermissions = ROLE_HIERARCHY[role] || [];
  return [role, ...directPermissions];
};

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
  
  setUser: (user) => set({ 
    user, 
    isAuthenticated: !!user, 
    error: null 
  }),
  
  setLoading: (isLoading) => set({ isLoading }),

  setError: (error) => set({ error }),
  
  logout: () => set({ 
    user: null, 
    isAuthenticated: false, 
    error: null 
  })
}));
